import { gReq } from 'api/fetch'
import { Account } from 'state/types'
//import { transformProfileResponse } from './helpers'


export interface GetAccountResponse {
  account?: Account
}



const getAccount = async (address: string): Promise<GetAccountResponse> => {
  try {
    
    const body = {
      url: '/account/getAccountByAddress',
      param: {
          address: address
      }
    }
    const data = await gReq(body)
    const account = data as Account
    return { account }
  } catch (error) {
    return null
  }
}

export default getAccount
